/* global axios */
import ApiClient from './ApiClient';

class LeadActivitiesAPI extends ApiClient {
  constructor() {
    super('leads', { accountScoped: true, apiVersion: 'v2' });
  }

  urlFor(leadId) {
    return `${this.url}/${leadId}/activities`;
  }

  pendingUrl() {
    return `${this.apiVersion}/accounts/${this.accountIdFromRoute}/users/pending_activities`;
  }

  index(leadId) {
    return axios.get(this.urlFor(leadId));
  }

  create(leadId, payload) {
    return axios.post(this.urlFor(leadId), { activity: payload });
  }

  update(leadId, id, payload) {
    return axios.patch(`${this.urlFor(leadId)}/${id}`, { activity: payload });
  }

  destroy(leadId, id) {
    return axios.delete(`${this.urlFor(leadId)}/${id}`);
  }

  complete(leadId, id, payload) {
    return axios.post(`${this.urlFor(leadId)}/${id}/complete`, payload);
  }

  myPending() {
    return axios.get(this.pendingUrl());
  }
}

export default new LeadActivitiesAPI();
